import { combineReducers } from 'redux';

import {
  PasswordRecoveryPayload,
  PasswordRecoveryAction,
} from '../types';
import {
  resetForm,
  passwordRecoveryRequest,
} from '../actions';

const email = (state = '', action: PasswordRecoveryAction) => {
  switch (action.type) {
    case passwordRecoveryRequest.type:
      return action.payload.email;

    case resetForm.type:
      return state = '';

    default:
      return state;
  }
};


export default combineReducers<PasswordRecoveryPayload>({
  email
});
